<template>
  <div id="delegaciones-tramites-new-or-edit">
    <LmComponentLoading v-if="loading" fixed />
    <LmFormBuilder
      ref="lmFormBuilder"
      :endpointUriwhereGetComponents="`formbuilder/${idFormBuilder}`"
      :endpointUriWhereGetValuesToLoadInEditMode="$route.params.id && `delegaciones/${$route.params.id}`"
      @formObjectToSendToServerChange="onFormObjectToSendToServerChange($event)"
      @formLoadingComplete="onFormLoadingComplete"
      />
    <portal to="destination-after-title">
      <div class="container-fluid">
        <b-row v-if="vecinoIsLoading">
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
          <b-col cols="4"><b-skeleton type="input"></b-skeleton></b-col>
        </b-row>
        <div v-else class="row">
          <LmTextInput
            class="col-4"
            v-model="vecino.NumeroDocumento"
            label="Documento"
            :disabled="true"
          />
          <LmTextInput
            class="col-4"
            v-model="vecino.Nombre"
            label="Nombre"
            :disabled="true"
          />
          <LmTextInput
            class="col-4"
            v-model="vecino.Apellido"
            label="Apellido"
            :disabled="true"
          />
        </div>
      </div>
    </portal>
    <portal to="destination-5">
      <div class="col-12 mt-3">
        <LmTextInput
          class="col-12 pr-0 pl-0"
          label="Buscador dirección"
          @search="searchAddress($event)"
          @itemWasSeleted="addresWasSelected($event)"
          v-model="form.domicilio"
          :modeItemsInputList="true"
          :isProcessingInputList="isSearchForAddress"
          :itemsInputList="itemsInputList"
          :maxLength="500"
        />
        <LmLeaFletMap :markerLatLng="addressMarker" :centerMapCoordinate="addressMarker" />
      </div>
    </portal>
    <portal to="button-submit">
      <div class="row">
        <LmButton
          class="col-4"
          id="boton-crear"
          value="Crear Trámite"
          type="submit"
          buttonClass="btn-primary"
          @click.native="submit"
          />
        <LmButton
          class="col-4 offset-2 pl-0"
          id="boton-claim"
          value="Reclamar Trámite"
          type="submit"
          buttonClass="btn-success"
          @click.native="claim"
          :disabled="!isOnEditMode"
          />
      </div>
    </portal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import _ from 'lodash'
import commonsApi from '@/api/commons'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import lmFormMixinV2 from '@/mixins/lmFormMixinV2.js'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmFormMixinV2, lmToasts],
  data () {
    return {
      loading: false,
      addressMarker: [],
      map:
        {
          LMap: {
            props: {
              center: [-34.5111791, -58.4902801],
              zoom: 13,
              minZoom: 0,
              maxZoom: 18,
              options: { zoomControl: true }
            }
          }
        },
      isSearchForAddress: false,
      itemsInputList: [],
      vecinoIsLoading: true,
      form: {
        NumeroDocumento: null,
        domicilio: '',
        location: {
          coordinates: []
        }
      },
      initialForm: {}
    }
  },
  props: {
    idFormBuilder: {
      type: String,
      required: true
    },
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    vecinoEndpointUri: {
      type: String,
      required: true
    },
    claimEndpointUri: {
      type: String,
      required: true
    }
  },
  components: {
    LmFormBuilder,
    LmTextInput,
    LmButton,
    LmLeaFletMap
  },
  validations: {
    form: {
      NumeroDocumento: {
        required
      },
      location: {
        coordinates: {
          required
        }
      }
    }
  },
  methods: {
    addresWasSelected (item) {
      this.form.domicilio = item.text
      this.addressMarker = [item.value.lat, item.value.lng]
      this.form.location.coordinates = [item.value.lng, item.value.lat]
    },
    async searchAddress (value) {
      this.isSearchForAddress = true
      try {
        const serverResponse = await commonsApi.axiosGetWrapper(`lugares/search?term=${value}`)
        const items = serverResponse.data.items
        this.itemsInputList = []
        for (const item of items) {
          this.itemsInputList.push({ id: item.placeId, text: item.displayName, value: { lat: item.lat, lng: item.lon } })
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        this.isSearchForAddress = false
      }
    },
    onFormLoadingComplete () {
      // Una vez que formbuilder termino de cargar ya tenemos a disposición todos los
      // datos que del formulario en this.form.
      // Seteamos addressMarkers con el la posicion geografica previamente guardada
      if (this.form.location?.coordinates.length) {
        this.addressMarker = [this.form.location.coordinates[1], this.form.location.coordinates[0]]
      }
    },
    async submit () {
      if (!this.isOnEditMode) {
        try {
          const lmFormBuilderValidations = this.validationForm(this.$refs.lmFormBuilder.$v, false)
          const formValidation = this.validationForm(this.$v, false)
          await Promise.all([lmFormBuilderValidations, formValidation])
          this.loading = true
          await commonsApi.axiosPostWrapper(this.newOrEditEndpointUri, this.form)
          this.lmToastSuccessInternalLink(`/delegaciones/consultas`, 'Trámite creado', 'Se guardó exitosamente')
          setTimeout(() => {
            this.loading = false
            this.$router.push('/delegaciones/consultas')
          }, 650)
        } catch (error) {
          console.log(error)
          this.loading = false
          this.showToastFormError()
        }
      }
    },
    // Reiteracion del trámite
    async claim () {
      if (this.isOnEditMode) {
        try {
          const lmFormBuilderValidations = this.validationForm(this.$refs.lmFormBuilder.$v, false)
          const formValidation = this.validationForm(this.$v, false)
          await Promise.all([lmFormBuilderValidations, formValidation])
          this.loading = true
          await commonsApi.axiosPostWrapper(this.claimEndpointUri, { id: this.$route.params.id })
          this.lmToastSuccessInternalLink(`/delegaciones/consultas`, 'Trámite reiterado', 'Se guardó exitosamente')
          setTimeout(() => {
            this.loading = false
            this.$router.push('/delegaciones/consultas')
          }, 650)
        } catch (error) {
          console.log(error)
          this.loading = false
          this.showToastFormError()
        }
      }
    },
    async setForm () {
      commonsApi.axiosGetWrapper(`${this.vecinoEndpointUri}${this.$route.params.documento}`)
        .then(resp => {
          if (Array.isArray(resp.data) && resp.data.length) {
            this.vecino = resp.data[0]
            this.form.NumeroDocumento = this.vecino.NumeroDocumento
          }
          this.vecinoIsLoading = false
        })
        .catch(e => {
          this.vecinoIsLoading = false
        })
      if (!this.isOnEditMode) {
        this.form = JSON.parse(this.initialForm)
        this.showLoading()
        setTimeout(() => {
          this.$v.$reset()
          this.hideLoading()
        }, 350)
      }
    },
    onFormObjectToSendToServerChange (formDataFromLmFormBuilder) {
      for (const key in formDataFromLmFormBuilder) {
        // cloneDeep es necesario para asegurarnos que cada asignacion sea efectuada
        // por valor y no por referencia.
        this.form[key] = _.cloneDeep(formDataFromLmFormBuilder[key])
      }
      console.log(formDataFromLmFormBuilder)
    }
  },
  async created () {
    this.isOnEditMode = !!this.$route.params.id
    // Obtenemos la informacion del vecino
    commonsApi.axiosGetWrapper(`${this.vecinoEndpointUri}${this.$route.params.documento}`)
      .then(resp => {
        if (Array.isArray(resp.data) && resp.data.length) {
          this.vecino = resp.data[0]
          this.form.NumeroDocumento = this.vecino.NumeroDocumento
        }
        this.vecinoIsLoading = false
      })
      .catch(e => {
        this.vecinoIsLoading = false
      })

    if (!this.isOnEditMode) {
      this.showLoading()
      setTimeout(() => {
        this.$v.$reset()
        this.hideLoading()
      }, 350)
    }
    await this.$nextTick()
  }
  // async created () {
  //   this.isOnEditMode = !!this.$route.params.id
  //   this.setForm()
  //   await this.$nextTick()
  //   // for (const key in this.$refs.lmFormBuilder.formObjectToSendToServer) {
  //   //   const value = this.$refs.lmFormBuilder.formObjectToSendToServer[key]
  //   //   this.$set(this.form, key, value)
  //   // }
  // }
}
</script>
